import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import { ArrowRightIcon } from './Icons';
import './Hero.css';

const Hero = () => {
  const { setView, setFilters } = useContext(ShopContext);
  const [activeSlide, setActiveSlide] = useState(0);
  const heroSlides = [
    '/images/hero-slide-1.webp',
    '/images/hero-slide-2.webp',
    '/images/hero-slide-3.webp'
  ];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide(current => (current + 1) % heroSlides.length);
    }, 3500);
    return () => window.clearInterval(timer);
  }, [heroSlides.length]);

  const openAll = () => {
    setFilters(prev => ({ ...prev, category: 'All', gender: 'All', subCategory: 'All', search: '' }));
    setView('shop');
  };

  const getAnimationClass = (index) => {
    if (index === 0) return 'zoom';
    if (index === 1) return 'slide-lr';
    return 'slide-tb';
  };

  return (
    <>
      <section className="hero-section">
        <div className="hero-slides" aria-hidden="true">
          {heroSlides.map((image, index) => (
            <div
              key={image}
              className={`hero-bg-image ${getAnimationClass(index)} ${index === activeSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${image}), url(/build${image}), url(${image.replace('.webp', '.png')})` }}
            >
              {index === 0 && (
                <img
                  src={image}
                  alt="PallyWear Premium Hero"
                  style={{ opacity: 0, position: 'absolute', pointerEvents: 'none', width: '100%', height: '100%', objectFit: 'cover' }}
                  fetchPriority="high"
                  width="1536"
                  height="1024"
                />
              )}
            </div>
          ))}
        </div>
        <div className="hero-overlay" />
        
        <div className="hero-content container">
          <h1 className="hero-title sr-only" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }}>
            Custom Apparel & Promotional Products | Pallywear - Order premium custom apparel, sports jerseys, and corporate wear from Pallywear. High-quality promotional products with MOQ starting from 1 piece.
          </h1>
          <div className="hero-actions">
            <button onClick={openAll} className="btn btn-primary hero-btn-primary">
              Shop The Drop <ArrowRightIcon size={17} />
            </button>
            <button onClick={() => setView('about')} className="hero-text-link">
              Our Craft & Story <span>↗</span>
            </button>
          </div>
        </div>

        <div className="hero-pagination" aria-label="Hero slides">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              className={index === activeSlide ? 'active' : ''}
              onClick={() => setActiveSlide(index)}
              aria-label={`Show slide ${index + 1}`}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Hero;
